<template>
  <el-dialog
    v-model="open"
    title=""
    width="1000"
    top="6vh"
    modal-class="video-dialog-txy-778yy"
    destroy-on-close
    :close-on-click-modal="false"
    @open="onOpen"
    @closed="closedModal"
    append-to-body
  >
    <div v-if="!videoSrc" style="width: 960px; height: 540px">
      <video id="tx-player" preload="auto" playsinline webkit-playsinline style="width: 100%; height: 100%" @keydown="handleKeyDown"></video>
    </div>
    <div v-else style="width: 960px; height: 540px">
      <video controls autoplay controlsList="nodownload" oncontextmenu="return false;" style="width: 100%">
        <source :src="videoSrc" type="video/mp4" />
        <source :src="videoSrc" type="video/webm" />
        <source :src="videoSrc" type="video/ogg" />
      </video>
    </div>
  </el-dialog>
</template>

<script setup>
import { getVideoPlayToken, recordDuration } from '@/api/education/courseContentLibrary';
import TCPlayer from 'tcplayer.js';
import 'tcplayer.js/dist/tcplayer.min.css';
import { ElMessage } from 'element-plus';
import useUserStore from '@/store/modules/user';

const { userInfo } = useUserStore();
const props = defineProps({
  videoId: {
    type: String,
  },
});

const emits = defineEmits(['refresh']);
let isTPlay = false; // 是否正在播放
let tPlayer = null;

const open = defineModel('visible', { type: Boolean, required: true, default: false });

const videoSrc = ref('');

function onOpen() {
  handleVideo();
  remarksVideos();
}

//获取视频
function handleVideo() {
  getVideoPlayToken(`${userInfo.userId}/${props.videoId}`)
    .then((res) => {
      if (res.data?.url) {
        videoSrc.value = res.data.url;
      } else {
        if (!res.data?.token) {
          videoSrc.value = res.data.basicInfo.mediaUrl;
          return;
        }
        tPlayer = TCPlayer('tx-player', {
          fileID: res.data.basicInfo.vid,
          appID: res.data.subAppId,
          psign: res.data.token,
          licenseUrl: 'https://license.vod2.myqcloud.com/license/v2/1321573871_1/v_cube.license',
          language: 'en',
          autoplay: true,
          disableRemotePlayback: false,
          width: '100%',
          height: '100%',
          playbackRates: [0.8, 1, 1.2, 1.5, 2],
          languages: {
            en: {
              '360P': '流畅',
              高清: '高清',
              auto: '标清',
            },
          },
        });

        tPlayer.on('loadstart', () => {});

        // 腾讯视频播放完毕
        tPlayer.on('ended', () => {
          isTPlay = false;
        });

        // 腾讯视频暂停
        tPlayer.on('pause', () => {
          isTPlay = false;
        });

        // 腾讯播放视频
        tPlayer.on('playing', () => {
          isTPlay = true;
        });
        // 腾讯播放视频
        tPlayer.on('error', (error) => {
          switch (error.data.code) {
            case 1013:
              ElMessage.error('该视频未转码，无法播放。');
              break;
            case 1001:
              ElMessage.error('该视频不存在，无法播放。');
              break;
          }
          open.value = false;
        });
      }
    })
    .catch(() => {
      open.value = false;
    });
}

function handleKeyDown(ev) {
  switch (ev.which) {
    case 32: // 空格键
      if (isTPlay) {
        tPlayer.pause();
      } else {
        tPlayer.play();
      }
      break;
    case 39: // 右键(快进)
      const next = tPlayer.currentTime() + 10;
      const timeN = next >= tPlayer.duration() ? tPlayer.duration() : next;
      tPlayer.currentTime(timeN);
      showMsg('播放进度：' + formatSeconds(timeN));
      break;
    case 37: // 左键(快退)
      const prev = tPlayer.currentTime() - 10;
      const timeP = prev <= 0 ? 0 : prev;
      tPlayer.currentTime(timeP);
      showMsg('播放进度：' + formatSeconds(timeP));
      break;
    case 38: // 上
      const upV = parseFloat((tPlayer.volume() + 0.1).toFixed(2));
      const volumeM = upV >= 1 ? 1 : upV;
      tPlayer.volume(volumeM);
      showMsg('音量：' + (volumeM * 100).toFixed(0) + '%');
      break;
    case 40: // 下
      const downV = parseFloat((tPlayer.volume() - 0.1).toFixed(2));
      const volumeD = downV <= 0 ? 0 : downV;
      tPlayer.volume(volumeD);
      showMsg('音量：' + (volumeD * 100).toFixed(0) + '%');
      break;
  }
}

/*
 * 工具方法：格式化秒为时分秒
 */
function formatSeconds(value) {
  let second = parseInt(value),
    minute = 0,
    hour = 0;
  if (second >= 60) {
    minute = parseInt(second / 60);
    second = parseInt(second % 60); //  获取秒数，秒数取佘，得到整数秒数
    if (minute >= 60) {
      hour = parseInt(minute / 60);
      minute = parseInt(minute % 60); //  获取小时后取佘的分，获取分钟除以60取佘的分
    }
  }

  const showS = parseInt(second) < 10 ? '0' + parseInt(second) : parseInt(second);
  let result = '0:' + showS;
  if (minute > 0) {
    result = '' + parseInt(minute) + ':' + showS;
  }
  if (hour > 0) {
    const showM = parseInt(minute) < 10 ? '0' + parseInt(minute) : parseInt(minute);
    result = '' + parseInt(hour) + ':' + showM + ':' + showS;
  }
  return result;
}

function showMsg(msg) {
  ElMessage.closeAll();
  ElMessage.info({
    appendTo: '#tx-player',
    message: msg,
  });
}

//视频播放打点
let timeout = null;
function remarksVideos(interval = 3000) {
  timeout = setInterval(() => {
    recordDuration({ fileId: props.videoId, type: 2, duration: interval }).catch(() => {
      clearInterval(timeout);
      timeout = null;
    });
  }, interval);
}

function closedModal() {
  videoSrc.value &&= '';
  isTPlay = false;
  if (timeout) {
    clearInterval(timeout);
    timeout = null;
  }
  emits('refresh');
  if (tPlayer != null) {
    tPlayer.pause();
    tPlayer.dispose();
    tPlayer = null;
  }
}
</script>

<style lang="scss">
.msg-wrapper-txy {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 2147483648;
  background-color: #333;
  border-radius: 8px;
  padding: 8px 12px;
  color: white;
  font-size: 16px;
  line-height: 22px;
  opacity: 0;
  transition: opacity 0.2s linear;
  pointer-events: none;
}

.video-dialog-txy-778yy {
  .el-dialog {
    background-color: transparent;
    box-shadow: none;

    .el-dialog__headerbtn {
      transform: scale(2);
      //position: relative;
      top: -20px;
      right: -20px;
    }
  }
}
</style>
